var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKosher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.1818V3H5.84446V7.67827H5.96875L9.94105 3H12.1932L8.25568 7.56889L12.228 13.1818H10.0107L6.97301 8.81676L5.84446 10.1491V13.1818H4Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosher);
export default __webpack_public_path__ + "static/media/kosher.d1c174807c264b1e550ce244f9b5bc1e.svg";
export { ForwardRef as ReactComponent };